import { Container, Stack, Typography, useTheme } from "@mui/material";
import { t } from "i18next";
import { useState } from "react";
import { Trans } from "react-i18next";
import { useNavigate } from "react-router-dom";
import AuthContainer from "../../../components/AuthContainer.js/index.js";
import GlobalButton from "../../../components/CustomButton/index.js";
import appcolors from "../../../constants/Colors.js";

let serviceCategory = [
  {
    name: "becomeCreator",
    type: "creator",
    isDisable: false,
  },

  {
    name: "becomeServiceProviderOrCleaner",
    type: "company",
    isDisable: false,
  },
  {
    name: "becomeSupplier",
    type: "supplier",
    isDisable: false,
  },
];

const JoinUs = () => {
  const { palette } = useTheme();
  const navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState("");

  const renderCategories = (category) => {
    return (
      <Stack spacing={1.5} mt={5}>
        {category.map((val, index) => {
          const isMatched = selectedCategory === val.type;
          const isCompanyOrCleaner =
            val.type === "company" || val.type === "cleaner";
          return (
            <GlobalButton
              key={index}
              variant={"outlined"}
              btnText={t(val.name)}
              handleClickBtn={() => {
                setSelectedCategory(val.type);
                if (isCompanyOrCleaner) {
                  navigate("/company/profile-type");
                } else {
                  navigate("/login", { state: { type: val.type } });
                }
              }}
              disabled={val?.isDisable}
              disableRipple={val?.isDisable}
              styleProps={{
                fontWeight: 500,
                fontSize: "1rem",
                backgroundColor: isMatched ? "primary.main" : "transparent",
                color: isMatched ? "custom.white" : "primary.main",
                width: "100%",
              }}
              hoverProperties={{
                backgroundColor: "primary.main",
                color: "custom.white",
              }}
            />
          );
        })}
      </Stack>
    );
  };
  return (
    <>
      <AuthContainer>
        <Container maxWidth={"xs"}>
          <Stack textAlign={"center"}>
            <Typography variant="auth_primary_text" component={"h1"}>
              {t("joinUs")}
            </Typography>
            <Typography variant="auth_secondary_text" component={"p"}>
              <Trans
                i18nKey="welcomeMessage"
                style={{ color: appcolors.slateGrey }}
                color={appcolors.slateGrey}
              >
                Welcome to <b style={{ color: "black" }}>Eaziday</b> CRM, Please
                Select a Type
              </Trans>
            </Typography>
          </Stack>

          {renderCategories(serviceCategory)}
        </Container>
      </AuthContainer>
    </>
  );
};

export default JoinUs;
